import { useState } from 'react'

const useLoading = (initiallyLoading = false) => {
  const [isLoading, setIsLoading] = useState(initiallyLoading)

  return {
    isLoading,
    loading: () => setIsLoading(true),
    done: () => setIsLoading(false)
  }
}
export default useLoading